import parse from "html-react-parser";

export default function DynamicMultiSelectField({
                                                    field,
                                                    value = [],
                                                    onFieldChange,
                                                    error
                                                }) {

    function handleChange(option) {
        let updatedValues;

        if (value.includes(option)) {
            updatedValues = value.filter(v => v !== option);
        } else {
            updatedValues = [...value, option];
        }

        onFieldChange({
            target: {
                id: field.code,
                value: updatedValues
            }
        });
    }

    return (
        <div>
            <label className="block text-x font-medium mb-1" htmlFor={field.code}>
                {field.name} {field.required && (<span className="text-red-600">*</span>)}
            </label>
            {field.help && (
                <div className="text-sm text-gray-500 mt-1 mb-2">
                    {parse(field.help)}
                </div>
            )}

            <div className={`
                border rounded-lg p-3 space-y-2
                ${error
                ? "border-red-500"
                : "border-gray-300"
            }
            `}>

                {field.values.map(option => (
                    <label
                        key={option}
                        className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 rounded px-2 py-1"
                    >
                        <input
                            type="checkbox"
                            checked={value.includes(option)}
                            onChange={() => handleChange(option)}
                            className="accent-[#1C3353]"
                        />
                        <span>{option}</span>
                    </label>
                ))}

            </div>

            {error && (
                <div className="text-red-600 text-sm mt-1">
                    {error}
                </div>
            )}
        </div>
    );
}
